import { combineReducers } from 'redux';

import deductionsReducer from './Deductions/slice';
import taxesPaidReducer from './TaxesPaid/slice';
import taxesPaidSpouseReducer from './TaxesPaidSpouse/slice';

export default combineReducers({
  deductions: deductionsReducer,
  taxesPaid: taxesPaidReducer,
  taxesPaidSpouse: taxesPaidSpouseReducer,
});
